import {
  Avatar,
  DialogContent,
  Icon,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setEditMode } from '../../redux/features/editModeSlice';
import { useLocation } from 'react-router-dom';
import { useMainFrameState } from '../MainUIFrame/MainFrame';
import { useConfirm } from 'material-ui-confirm';
import { resetStateDetectorState } from '../../redux/features/stateDetectorSlice';
import CustomConfirmDialog from '../customConfirmationDialog';

const EHRToolbar = props => {
  const editMode = useSelector(state => {
    return state?.edit?.editMode;
  });

  const { isDark } = useMainFrameState();

  const toolbarState = useSelector(state => {
    return state?.toolbar;
  });

  const isEditModeDisabled = useSelector(state => {
    return state?.backdrop?.progress;
  });
  const { arePermissionsChanged } = useSelector(state => state?.stateDetector);

  const reduxDispatch = useDispatch();

  const isPatientStateChanged = useSelector(
    state => state?.stateDetector?.isPatientStateChanged
  );

  // const confirmation = useConfirm();
  const confirmation = CustomConfirmDialog;

  const location = useLocation();
  const handleOnChange = event => {
    const { name, checked } = event?.target;
    if (name === 'editToggle') {
      if (isPatientStateChanged || arePermissionsChanged) {
        const options = {
          message:
            'You have some unsaved work. Do you still want to leave the page?',
          confirmationText: 'Leave',
          isDark,
        };
        confirmation(options)
          //   {
          //   description: (
          //     <DialogContent>
          //       You have some unsaved work. Do you still want to leave the page?
          //     </DialogContent>
          //   ),
          //   dialogProps: {
          //     style: {
          //       zIndex: 2000,
          //     },
          //     classes: {
          //       paper: isDark ? 'darkDialogPaper' : 'lightDialogPaper',
          //       color: isDark ? '#fff' : '#222',
          //     },
          //     PaperProps: {
          //       style: {
          //         backgroundColor: isDark ? '#222' : '#fff',
          //         color: isDark ? '#fff' : '#333',
          //       },
          //     },
          //   },
          // })
          .then(() => {
            reduxDispatch(resetStateDetectorState());
            reduxDispatch(setEditMode(checked));
          })
          .catch(e => {});
      } else {
        reduxDispatch(setEditMode(checked));
      }
    }
  };

  const toolBarContent = (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          maxHeight: '40px',
          minHeight: '40px',
        }}
      >
        <Box>
          {toolbarState?.toolbarPossibleActions?.map(action => {
            // Skip rendering the library_add_check_rounded_icon icon if location.pathname doesn't include '/claims'
            if (
              action.icon === 'library_add_check_rounded_icon' &&
              !location.pathname.endsWith('/claims')
            ) {
              return null;
            }
            // Skip rendering the playlist_add_circle_rounded_icon icon if location.pathname doesn't include '/claims'
            if (
              action.icon === 'playlist_add_circle_rounded_icon' &&
              !location.pathname.endsWith('/claims')
            ) {
              return null;
            }
            if (
              action.icon === 'sync_rounded_icon' &&
              !location.pathname.endsWith('/claims')
            ) {
              return null;
            }
            /* if (
              action.icon === 'cancel' &&
              !location.pathname.endsWith('/claim/record')
            ) {
              return null;
            } */
            // if (
            //   action.icon === 'cancel' &&
            //   !location.pathname.endsWith('/claim/record')
            // ) {
            //   return null;
            // }
            return (
              <>
                <Tooltip title={action?.title.replace(/_/g, ' ')}>
                  <IconButton
                    onClick={() =>
                      typeof action.clickAction === 'function'
                        ? action?.clickAction()
                        : {}
                    }
                    disabled={action?.disabled}
                  >
                    {action.hasOwnProperty('image') && action?.image ? (
                      <>
                        <Avatar
                          alt={action.title}
                          src={action.image}
                          sx={{ width: 24, height: 24 }}
                        />
                      </>
                    ) : (
                      <Icon
                        sx={{
                          color: action?.disabled
                            ? 'grey'
                            : isDark
                            ? '#80b6ba'
                            : 'toolBarIcon',
                        }}
                      >
                        {action?.icon}
                      </Icon>
                    )}
                  </IconButton>
                </Tooltip>
              </>
            );
          })}
        </Box>
        {toolbarState.editSwitch &&
        !location.pathname.includes('location/view/new') ? (
          <Box
            sx={{
              mr: 2,
            }}
          >
            <Stack direction={'row'} spacing={1} alignItems={'center'}>
              <Typography
                sx={{
                  color: 'toolBarIcon',
                }}
              >
                View
              </Typography>
              <Switch
                name="editToggle"
                checked={editMode}
                onChange={handleOnChange}
                disabled={isEditModeDisabled}
              />
              <Typography
                sx={{
                  color: 'toolBarIcon',
                }}
              >
                Edit
              </Typography>
            </Stack>
          </Box>
        ) : (
          <></>
        )}
      </Box>
    </>
  );

  return <>{toolBarContent}</>;
};

export default EHRToolbar;
